export default "__VITE_ASSET__BhlOYnyt__"